module.exports = __webpack_public_path__ + "images/7dc1d34a4abc280ec0bfe4a88a42f20a.png";